import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from "axios";
import style from "./ModalContent.module.sass";
import classnames from 'classnames';
import TeacherItem from './TeacherItem';

const ModalContent = ({ data, schoolId, onChange }) => {
  const [isDraggable, setIsDraggable] = useState(false);
  const [dragOverId, setDragOverId] = useState();
  const [teachers, setTeachers] = useState(data);
  // The summary above the table reads the rows as edited, not as loaded.
  useEffect(() => { if (onChange) onChange(teachers); }, [teachers]);
  const hasWarning = (teacher) => (teacher.warnings || []).some((w) => (w.level === 'warning' || w.level === 'alert'));

  const handleDragUpdate = ({ combine }) => {
    setDragOverId(combine ? combine.draggableId : combine)
  };

  const handleDragEnd = ({ source, combine }) => {
    if (combine) {
      const { index } = source;
      const { draggableId } = combine;
      const teacherToBeMerged = teachers[index];
      const teacherToBeMergedInto = teachers.find((teacher) => teacher.teacher_id.toString() === draggableId)

      confirmAlert({
        title: 'Confirm Merge',
        message: `Are you sure you want to merge ${teacherToBeMerged.teacher_name}'s students (${teacherToBeMerged.student_count}) into ${teacherToBeMergedInto.teacher_name}'s class? (${teacherToBeMergedInto.student_count} students)`,
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              axios
                .post(`/api/v1/students/merge_teachers?school_id=${schoolId}&teacher_to_be_merged_into=${teacherToBeMergedInto.teacher_id}&teacher_to_be_merged=${teacherToBeMerged.teacher_id}`)
                .then((data) => {
                  const updatedTeachers = teachers.filter((teacher) => teacher.teacher_id !== teacherToBeMerged.teacher_id);
                  const updatedStudentCount = updatedTeachers.map((teacher) => {
                    if (teacher.teacher_id === teacherToBeMergedInto.teacher_id) {
                      return data.data.data
                    } else {
                      return teacher
                    }
                  })

                  setTeachers(updatedStudentCount)
                })
            }
          },
          {
            label: 'No',
            onClick: () => {}
          }
        ]
      });
    }

    setDragOverId(null);
  };

  const checkIsDraggable = snapshot => {
    const { isDragging, draggingOver } = snapshot;

    if (isDragging && !draggingOver) {
      setIsDraggable(false);
    }
  };

  const getItemStyle = (draggableStyle, snapshot) => {
    if (!snapshot.isDragging) return {};

    const { transform } = draggableStyle;
    let activeTransform = {};

    if (transform) {
      activeTransform = {
        transform: `translate(0, ${transform.substring(
          transform.indexOf(",") + 1,
          transform.indexOf(")")
        )})`
      };
    }
    return {
      userSelect: "none",
      ...draggableStyle,
      ...activeTransform,
    };

  };

  return (
    <DragDropContext
      onDragUpdate={handleDragUpdate}
      onDragEnd={handleDragEnd}
    >
      <p>Drag the teacher cards into each other to merge duplicate classrooms.</p>
        <Droppable droppableId="list-unique-id" isCombineEnabled>
          {({ innerRef, droppableProps, placeholder }) => {
            return (
              <div
                ref={innerRef}
                {...droppableProps}
                className={classnames(style.root)}
              >
                <table className={style.table}>
                {teachers.map((teacherList, index) => {
                  return (
                    <Draggable
                      draggableId={teacherList.teacher_id.toString()}
                      index={index}
                      key={teacherList.teacher_id}
                      isDraggable={isDraggable}
                    >
                      {(
                        { innerRef, draggableProps, dragHandleProps },
                        snapshot
                      ) => {
                        if (isDraggable) {
                          checkIsDraggable(snapshot);
                        }
                        return (
                          <tr
                            key={teacherList.teacher_id}
                            className={classnames(
                              style.item,
                              snapshot.isDragging && style.itemIsDragging,
                              dragOverId === teacherList.teacher_id.toString() && style.draggedOver,
                              teacherList.student_id && style.hasMatch,
                              teacherList.needs_review && style.needsReview,
                              hasWarning(teacherList) && style.hasWarning,
                            )}
                            title={teacherList.needs_review ? 'Needs review: no staff record matched — enter a display name or link a student record' : undefined}
                            ref={innerRef}
                            {...draggableProps}
                            {...dragHandleProps}
                            style={getItemStyle(draggableProps.style, snapshot)}
                          >
                            <TeacherItem
                              teacherList={teacherList}
                              schoolId={schoolId}
                              teachers={teachers}
                              setTeachers={setTeachers}
                            />
                          </tr>
                        );
                      }}
                    </Draggable>
                  )
                })}
                </table>

                <span
                  style={{
                    display: "none"
                  }}
                >
                {placeholder}
              </span>
              </div>
            )
          }}
        </Droppable>
    </DragDropContext>
  )
}

export default ModalContent;
